import { render, staticRenderFns } from "./TransactionEventTicketPurchase.vue?vue&type=template&id=1708376e&functional=true&"
import script from "./TransactionEventTicketPurchase.vue?vue&type=script&lang=ts&"
export * from "./TransactionEventTicketPurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports